import { setupApiClient } from './api';
import { setupFPApiClient } from './fpAPI';

export const api = setupApiClient();
export const fpAPI = setupFPApiClient();
